export default __webpack_public_path__ + "media/icons/carouselArrowNext-a68e6a2a.svg";